import { logger as LOG, logger } from '@garnish/logger';
import { compareDesc, parseISO } from 'date-fns';
import { uniqBy } from 'lodash';

import { type CancelationCandidateOrder } from './orders-history-machine.types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * A tiny utility that removes potential duplicates from the order list,
 * which can occur if the user loads more orders with a delay.
 */
export function withoutDuplicateOrders<Order extends CancelationCandidateOrder>(
  orders: Order[],
): Order[] {
  return uniqBy(orders, 'id');
}

/**
 * A utility for sorting order lists based on the wanted time of the orders.
 */
export function sortOrdersByWantedTime<Order extends CancelationCandidateOrder>(
  orders: Order[],
): Order[] {
  return [...orders].sort((currentOrder, nextOrder) =>
    compareDesc(parseISO(currentOrder.wantedTime), parseISO(nextOrder.wantedTime)),
  );
}

// ─── Logger ──────────────────────────────────────────────────────────────────

export const ordersHistoryMachineLogger = logger.extend('ORDERS HISTORY STATE MACHINE');
